const lightTheme = {
  mode: "light",
  primary: {
    main: "#28AA4A",
  },  
  secondary: {
    main: "#00ABF4"
  },
  white:{
    main:"#fff",
  },
  black:{
    main:"#202020"
  },
  lightGray:{
    main:"#F1F1F1",
    dark:"#878787"
  },
  error: {
    main: "#FF0000"
  },
};

export default lightTheme;
